import React, { useContext } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  useParams
} from 'react-router-dom';

import { OrganisationContext, DroneContextProvider, DampReportContextProvider } from 'contexts';
import { DroneRegistration, DroneRenewal } from 'forms';
import SubmissionCancellation from 'forms/SubmissionCancellation';
import RequestAdditionalPayment from 'forms/RequestAdditionalPayment';
import AdditionalPaymentPage from 'pages/Payment/AdditionalPaymentPage';
import { Loader } from 'components/common';
import DampReportApplication from 'forms/DAMP/DampReportApplication';

const OrganisationRouteRouter: React.FC = () => {
  const match = useRouteMatch();
  const { organisationId } = useParams<{ organisationId: string; }>();

  const { organisationDetailsResponse } = useContext(OrganisationContext);

  return (
    <Switch>
      <Route exact path={`${match.path}/submissions/:submissionId/cancellation`}>
        <SubmissionCancellation />
      </Route>

      <Route exact path={`${match.path}/submissions/:submissionId/payment`}>
        <RequestAdditionalPayment />
      </Route>

      <Route exact path={`${match.path}/submissions/payment`}>
        <AdditionalPaymentPage />
      </Route>
      <Route exact path={`${match.path}/drone-registration`}>
        <DroneContextProvider organisationId={organisationId}>
          {
            organisationDetailsResponse?.loading // TODO: Should this possibly be undefined or can we give a default value to all service calls?
              ? <Loader />
              : <DroneRegistration />
          }
        </DroneContextProvider>
      </Route>
      <Route exact path={`${match.path}/drone-renewal`}>
        <DroneContextProvider organisationId={organisationId}>
          {
            organisationDetailsResponse?.loading // TODO: Should this possibly be undefined or can we give a default value to all service calls?
              ? <Loader />
              : <DroneRenewal />
          }
        </DroneContextProvider>
      </Route>
      <Route exact path={`${match.path}/damp-report`}>
        <DampReportContextProvider organisationId={organisationId}>
          {
            organisationDetailsResponse?.loading // TODO: Should this possibly be undefined or can we give a default value to all service calls?
              ? <Loader />
              : <DampReportApplication />
          }
        </DampReportContextProvider>
      </Route>
    </Switch>
  );
};

export default OrganisationRouteRouter;